import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingReaction = styled(motion.div)`
  position: fixed;
  font-size: 3rem;
  pointer-events: none;
  z-index: 1000;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
`;

function ReactionPanel({ reactions = [] }) {
  return (
    <AnimatePresence>
      {reactions.map((reaction) => (
        <FloatingReaction
          key={reaction.id}
          initial={{ 
            x: Math.random() * (window.innerWidth - 100),
            y: window.innerHeight - 150,
            opacity: 1,
            scale: 0.5
          }}
          animate={{ 
            y: -100,
            x: Math.random() * (window.innerWidth - 100),
            opacity: 0,
            scale: 2,
            rotate: (Math.random() - 0.5) * 60
          }}
          exit={{ opacity: 0 }}
          transition={{ 
            duration: 3,
            ease: "easeOut"
          }}
        >
          {reaction.emoji}
        </FloatingReaction>
      ))}
    </AnimatePresence>
  );
}

export default ReactionPanel;
